import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import App from './App';
import './locales/i18n';
import AuthProvider from './providers/AuthProvider';
import FactoryOptionsProvider from './providers/FactoryOptionsProvider';
import SocketProvider from './providers/SocketProvider';
import { store } from './redux/store';
// import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// ----------------------------------------------------------------------

const chunkLoadErrorKey = 'chunk-load-error-reloaded';

const shouldReloadForChunkError = (message: string | undefined): boolean =>
  Boolean(message && /ChunkLoadError|Loading chunk \d+ failed|Unexpected token '<'/i.test(message));

const attemptChunkReload = (message: string | undefined): void => {
  if (!shouldReloadForChunkError(message)) {
    return;
  }

  if (sessionStorage.getItem(chunkLoadErrorKey) === 'true') {
    return;
  }

  sessionStorage.setItem(chunkLoadErrorKey, 'true');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  attemptChunkReload(event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { message?: string } | undefined;
  attemptChunkReload(reason?.message ?? String(event.reason));
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <FactoryOptionsProvider>
            <App />
            <ToastContainer />
          </FactoryOptionsProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
